import { Box } from "@mui/material";
import styled from "styled-components";

export const VideoWrapper = styled(Box)`
  width: ${(props) => (props.width ? props.width : "auto")};
  height: ${(props) => (props.height ? props.height : "auto")};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
`;
